import { ContainerModule } from 'inversify';
import { CategoryServiceImpl } from './category-service';
import { CategoryApiImpl } from './repository/category-api';
import { CategoryApi } from './types/category-api.interface';
import { CategoryService } from './types/category-service.interface';
export const category = new ContainerModule(bind => {
    bind(CategoryService).to(CategoryServiceImpl);
    bind(CategoryApi).to(CategoryApiImpl);
});
export { CategoryServiceImpl } from './category-service';
export { CategoryApiImpl } from './repository/category-api';
export { CategoryApi } from './types/category-api.interface';
export { CategoryService } from './types/category-service.interface';
